import { gql } from 'apollo-angular';

const GET_CATEGORIZATION_SCHEME = gql`
  query categorizationScheme($id: Long!) {
    category(id: $id) {
      id
      name
    }
  }
`;

export default GET_CATEGORIZATION_SCHEME;
